import * as Actions from './common.actions';
import { ICommonState } from './common.state';
import { Action, createReducer, on } from '@ngrx/store';
import { MenuModel } from 'src/app/model/menu.model';
import { SystemConfigModel } from 'src/app/model/system-config.model';
import { LoggedInModel } from 'src/app/model/logged-in.model';
// import { LoggedInModel } from 'src/app/model/loggedIn.model';

export const commonState: ICommonState = {
  isLoading: false,
  screenWidth: window.innerWidth,
  menuList: [],
  systemConfig: {} as SystemConfigModel,
  loggedInModel: {} as LoggedInModel
};

const reducerList = createReducer(commonState,

  on(Actions.IsLoadingAction, (state, { payload }) => {
    if (state.isLoading == payload)
      return state;
    return {
      ...state,
      isLoading: payload,
    };
  }),

  on(Actions.ChangeScreenWidthAction, (state, { payload }) => {
    return {
      ...state,
      screenWidth: payload,
    };
  }),
  on(Actions.SetMenuAction, (state, { data }) => {
    return {
      ...state,
      menuList: data,
    };
  }),
  on(Actions.SystemConfigurationResponseAction, (state, { payload }) => {
    return {
      ...state,
      systemConfig: payload,
    };
  }),
  on(Actions.IsLoggedInResponseAction, (state, { data }) => {
    return {
      ...state,
      loggedInModel: data
    };
  }),

);

export function commonReducer(state: any | undefined, action: Action) {
  return reducerList(state, action);
}
